import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EnquiryAssessmentInfoModel } from './enquiry-assessment-info-model';

export class EnquiryAssessmentResponseModel extends GlobalResponseObject{
    data?: EnquiryAssessmentInfoModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EnquiryAssessmentInfoModel[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
